module.exports = {
      id: "nav-close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#nav-close-usage",
      toString: function () {
        return this.url;
      }
    }